export const IDS = {

    pnpDocumentApprovalGrid: 'pnpDocumentApprovalGrid',
   
    // settings categories states :
    app_policies_documents_approval: 'app.policies.documents.approval',
    app_policies_documents_approval_details: 'app.policies.documents.approval.details',
    app_policies_documents_approval_listing: 'app.policies.documents.approval.listing',
};